import {
  PasswordInput as PasswordInputMantine,
  PasswordInputProps,
  useMantineTheme,
} from "@mantine/core";
import { Lock } from "iconsax-react";

const PasswordInput = (props: PasswordInputProps) => {
  const theme = useMantineTheme();
  return (
    <PasswordInputMantine
      withAsterisk
      icon={<Lock size="17" color={theme.colors.basic[5]} />}
      visibilityToggleIcon={({ reveal }) =>
        reveal ? <p>Ocultar senha</p> : <p>Mostrar senha</p>
      }
      {...props}
    />
  );
};
export default PasswordInput;
